import { Component } from "@angular/core";
import { IHeaderAngularComp } from "@bfx/ag-grid-angular";
import { Long } from "shared/cubiq-model-multi-asset";
import { IHeaderParams } from "ag-grid-community";
import {
  HubConnectionService,
  HubConnectionStatusListener,
  TGStatus,
} from "shared/cubiq-services/model/HubConnectionService";

export const PARAM_TG_ID = "PARAM_TG_ID";
export const PARAM_TG_CD = "PARAM_TG_CD";
export const PARAM_TG_NAME = "PARAM_TG_NAME";
export const PARAM_NOTIF_SVC = "NOTIF_SVC";
export const PARAM_HUB_SVC = "HUB_SVC";

//NB TODO reusing connection monitor styles - may want to separate at some point
@Component({
  selector: "tg-status-columnheader",
  template: ` <div
      *ngIf="enableSorting && sortAscending === true"
      class="tg-status-columnheader ag-header-icon ag-sort-ascending-icon"
    >
      <span class="ag-icon ag-icon-asc"></span>
    </div>
    <div
      *ngIf="enableSorting && sortAscending === false"
      class="tg-status-columnheader ag-header-icon ag-sort-descending-icon"
    >
      <span class="ag-icon ag-icon-desc"></span>
    </div>
    <div class="ag-header-cell-label" (click)="onSortToggle($event)">
      <span class="ag-header-cell-text">
        <span [class]="connectionClass" title="{{ tgCd }} {{ statusDescription }}"></span>
        <span class="connection_monitor_status_title">{{ tgCd }}</span></span
      >
    </div>`,
  standalone: false,
})
export class TgStatusColumnHeaderComponent
  implements IHeaderAngularComp, HubConnectionStatusListener
{
  tgId: Long = null;
  tgCd: string = null;
  tgName: string = null;
  template: string;
  statusDescription: string;
  enableSorting: boolean = false;
  parameters: IHeaderParams;
  sortAscending: boolean = null;

  sortChangeListener: any = null;

  connectionStatus: TGStatus = TGStatus.ONLINE;
  connectionClass: string = "";

  constructor(protected hubService: HubConnectionService) {}

  agInit(params: IHeaderParams): void {
    this.parameters = params;

    this.tgId = params[PARAM_TG_ID];
    this.tgCd = params[PARAM_TG_CD];
    this.tgName = params[PARAM_TG_NAME];
    this.enableSorting = params.enableSorting;
    this.subscribeForNotifications();

    // Needed for when grid is refreshed
    this.onSortChanged();

    this.sortChangeListener = this.onSortChanged.bind(this);
    params.column.addEventListener("sortChanged", this.sortChangeListener);
  }

  ngOnDestroy() {
    this.unSubscribeFromNotifications();
  }

  subscribeForNotifications() {
    // subscribe will call onHubStatusChange to prime
    this.hubService.subscribe(this);
  }

  unSubscribeFromNotifications() {
    this.hubService.unsubscribe(this);
    if (this.parameters != null && this.parameters.column != null) {
      this.parameters.column.removeEventListener("sortChanged", this.sortChangeListener);
    }
  }

  getTgId(): Long {
    return this.tgId;
  }

  onSortChanged(): void {
    if (this.parameters.column.isSortAscending()) {
      this.sortAscending = true;
    } else if (this.parameters.column.isSortDescending()) {
      this.sortAscending = false;
    } else {
      this.sortAscending = null;
    }
  }

  onSortToggle(event): void {
    if (this.sortAscending == null) {
      this.sortAscending = false;
    }

    this.sortAscending = !this.sortAscending;
    this.onSortRequested(this.sortAscending ? "asc" : "desc", event);
  }

  onSortRequested(order, event): void {
    this.parameters.setSort(order);
  }

  onHubStatusChange(tgId: Long, status: TGStatus) {
    if (tgId.equals(this.tgId)) {
      this.connectionStatus = status;
      if (this.connectionStatus === TGStatus.ONLINE) {
        this.statusDescription = "Online";
        this.connectionClass = "bfx-badge-positive-bold-unsized bfx-badge-bold-xs";
      } else {
        this.statusDescription = "Offline";
        this.connectionClass = "bfx-badge-negative-bold-unsized bfx-badge-bold-xs";
      }
    }
  }
}
